import { createContext, useContext, useState } from "react";

const SportContext = createContext(null);

export const SportProvider = ({ children }) => {
  const [sport, setSport] = useState("NFL");
  return <SportContext.Provider value={{ sport, setSport }}>{children}</SportContext.Provider>;
};

export const useSport = () => useContext(SportContext);
